import React from "react";


const Loader = () => {
  return (
    <>
      <div className="loader-wrapper" >
        <div className="loader">
        <img src="./assets/images/loader.gif" alt="gif" />
        </div>
      </div>
    </>
  );
};

export default Loader;
